import { IconBase, type IconProps } from './IconBase';

export function FlameIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M12 3c1 3 5 5 5 10a5 5 0 0 1-10 0c0-2.5 1.5-4 2.5-5 0 2 1 3 2.5 3 0-3.5-1-5.5 0-8z" />
    </IconBase>
  );
}
